import { ImageMedia } from '@/components/ImageMedia';

import { ROUTES_RESOURCES } from '@/constants/routes.constants';
import { BREAKPOINTS } from '@/constants/viewport.constants';

export const LogoPNPrivate = ({ onClick }: { readonly onClick: () => void }) => (
	<button type="button" onClick={onClick}>
		<ImageMedia
			alt="Sede Electrónica Notarial. Empresa y personas"
			src={`${ROUTES_RESOURCES.IMAGES}/pnp-logo-mobile.svg`}
			mediaSources={[
				{
					media: `(width >= ${BREAKPOINTS.LANDSCAPE}px)`,
					srcSet: `${ROUTES_RESOURCES.IMAGES}/pnp-logo-desktop.svg`,
				},
			]}
		/>
	</button>
);

export const LogoPNPublic = ({ onClick }: { readonly onClick: () => void }) => (
	<button type="button" onClick={onClick}>
		<ImageMedia
			alt="Sede Electrónica Notarial"
			src={`${ROUTES_RESOURCES.IMAGES}/pnp-logo-basic-mobile.svg`}
			mediaSources={[
				{
					media: `(width >= ${BREAKPOINTS.LANDSCAPE}px)`,
					srcSet: `${ROUTES_RESOURCES.IMAGES}/pnp-logo-basic-desktop.svg`,
				},
			]}
		/>
	</button>
);
